import styled from 'styled-components';

export const PriceInputFilterWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const PriceInputFlexItem = styled.div<{ isMobile: boolean }>`
  flex: 1;
`;
